export default "__VITE_ASSET__Q$tAunj3__"